import { useState } from "react";
import { FaSyncAlt } from "react-icons/fa";
import { Modal, Button } from "react-bootstrap";

const SyncTabsHeader = ({ showZone, setShowZone, onGlobalSync }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleCloseConfirm = () => {
    setShowConfirmDialog(false);
  };

  const handleConfirm = () => {
    onGlobalSync();
    handleCloseConfirm();
  };

  const showConfirmation = () => {
    setShowConfirmDialog(true);
  };

  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <h2>Data Sync</h2>
        </div>
        <div className="col">
          <div className="row tabs">
            <div
              className={
                showZone == 0
                  ? "col text-center btn btn-sm btn-light active"
                  : "col text-center btn btn-sm btn-light"
              }
              onClick={() => setShowZone(0)}
            >
              All
            </div>
            <div
              className={
                showZone == 1
                  ? "col text-center btn btn-sm btn-light active"
                  : "col text-center btn btn-sm btn-light"
              }
              onClick={() => setShowZone(1)}
            >
              Courses
            </div>
            <div
              className={
                showZone == 2
                  ? "col text-center btn btn-sm btn-light active"
                  : "col text-center btn btn-sm btn-light"
              }
              onClick={() => setShowZone(2)}
            >
              CSLP
            </div>
            <div
              className={
                showZone == 3
                  ? "col text-center btn btn-sm btn-light active"
                  : "col text-center btn btn-sm btn-light"
              }
              onClick={() => setShowZone(3)}
            >
              Users
            </div>
          </div>
        </div>
        <div className="col-md-3 text-right">
          <button
            className="btn btn-sm btn-global-sync"
            onClick={showConfirmation}
          >
            <FaSyncAlt /> &nbsp;Force Global Sync
          </button>
        </div>
      </div>

      {/* Confirmation Dialog */}
      <Modal show={showConfirmDialog} onHide={handleCloseConfirm} centered>
        <Modal.Header closeButton>
          <Modal.Title>Force Global Sync</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to force a global sync? This will synchronize
            all data across the system.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseConfirm}
            className="btn btn-sm cts-btn-secondary"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            className="btn btn-sm cts-btn-primary"
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SyncTabsHeader;
